/*
module.exports = {
  home: {
    title: 'home',
    message: 'Welcome to the central peripheral platform',
    welcome:'Welcome,',
    signOut:'sign out',
    systemSettings:'System settings',
    changePassword:'Change Password',
    departmentSwitch:'Department switch',
    prompt:'prompt',
    outMsg:'Do you really want to log out?',
    errorTitle:'error',
    searchMenu:'Search menu',
    welcomeBack: 'Welcome back',
    welcomeTitle:'Welcome',
    loginFailed:'Login failed',
  },
  page:{
    total:' total_1_2_3 ',
    article:' article ',
  }
}*/
